import React, {PureComponent} from 'react';

class Category extends PureComponent {

  render() {
    const {name} = this.props;
    return (
      <div className="category">
        <h4>{name}</h4>
      </div>
    );
  }
}

Category.propTypes = {};
Category.defaultProps = {};

export default Category;



// WEBPACK FOOTER //
// ./src/components/category/Category.js